import { SelectEditor } from "../SelectEditor";

export class SelectEditorFactory {
    public static create<TOption>(): new () => SelectEditor<TOption> {
        type customSelectEditorCst = new () => SelectEditor<TOption>;
        const instance = (SelectEditor as any) as customSelectEditorCst;

        return instance;
    }
}
